// extracted by mini-css-extract-plugin
export var textInput = "_dn-0";